module.exports = __webpack_public_path__ + "img/collection-fill.ac91a418.svg";